import loadable from '@loadable/component';

const TicketGeneralServiceLoadable = loadable(() => import(/* webpackChunkName: "ticket-general-service-page" */ './index'));

export default TicketGeneralServiceLoadable;
